import { render, staticRenderFns } from "./EditRedirectSettings.vue?vue&type=template&id=151bc13a&scoped=true&"
import script from "./EditRedirectSettings.vue?vue&type=script&lang=js&"
export * from "./EditRedirectSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditRedirectSettings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EditRedirectSettings.vue?vue&type=style&index=1&id=151bc13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151bc13a",
  null
  
)

export default component.exports